export default __webpack_public_path__ + "static/media/gd.1ccf6d88.mp3";